'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findType;
function findType(tags) {
  var types = {
    country: 'country',
    city: 'city',
    'amenity/bus_station': 'busStop',
    'amenity/townhall': 'townhall',
    'railway/station': 'trainStation',
    'aeroway/aerodrome': 'airport',
    'aeroway/terminal': 'airport',
    'aeroway/gate': 'airport'
  };

  for (var t in types) {
    if (tags.indexOf(t) !== -1) {
      return types[t];
    }
  }

  return 'address';
}


//////////////////
// WEBPACK FOOTER
// ./~/places.js/src/findType.js
// module id = 1630
// module chunks = 1